import { useDevStore, PERMISSIONS } from '@/store/devStore'
import { useHubStore } from '@/store/hubStore'
import { useSessionStore } from '@/store/sessionStore'
import { apiMode } from '@/lib/hubApi'
import type { User } from '@/types'

/** The signed-in person and their permissions: on the API the session (LH-B1), else the dev switcher. */
export function useCurrentUser(): { user: User; can: (p: string) => boolean } {
  const id = useDevStore((s) => s.currentUserId)
  const users = useHubStore((s) => s.users)
  const view = useSessionStore((s) => s.view)
  if (apiMode() && view) {
    const user: User = { id: view.user.id, name: view.user.name, email: view.user.email, role: view.user.role, twoStep: view.user.two_step, lastSignInAt: null }
    return { user, can: (p) => view.permissions.includes(p) }
  }
  const user = users.find((u) => u.id === id) ?? users[0]!
  const perms = PERMISSIONS[user.role]
  return { user, can: (p) => perms.includes(p) }
}
